/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query LogsReadQuery($smppId: ID, $severity: SMPP_DEBUGGING_LEVEL, $take: PositiveInt, $skip: Int) {
    LogsRead(vendorAccountId: $smppId, severity: $severity, take: $take, skip: $skip) {
      id,
      createdAt,
      updatedAt,
      severity,
      output,
      status,
      message,
      _totalCount
    }
  }
`
